// require('dotenv').config();

// eslint-disable-next-line no-console
console.log('node environment =====', process.env.REACT_APP_NODE_ENV);
let BaseUrl;
let BUCKET;

switch (process.env.REACT_APP_NODE_ENV) {
  case 'staging':
    BaseUrl = 'https://staging-api.get-shoot.com/api/';
    BUCKET = 'shoot-staging';
    break;
  case 'production':
    BaseUrl = 'https://api.get-shoot.com/api/';
    BUCKET = 'shoot-production';
    break;
  default: // "development"
    BaseUrl = 'http://localhost:4000/api/';
    BUCKET = 'shoot-development';
    break;
}

module.exports = {
  BaseUrl,
  BUCKET,
  BUILD_BUCKET: 'shoot-app-builds',
};
